import Dashes = require("./linedash");

export =
    [
        {
            "stroke": {
                "color": "red",
                "width": 2,
                "lineDash": Dashes.dash
            }

        }
    ];